import { useCallback, useEffect, useState } from 'react'
import { api } from '../lib/api'
import type { LibraryGame, LibraryResponse } from '../lib/types'

/**
 * Fetches the logged-in user's synced Steam games for the /library page
 * (GET /api/v1/me/library). Thin — the server owns ordering + grounding; the
 * client only renders. Mirrors the useGroups pattern.
 */
export function useLibrary() {
  const [games, setGames] = useState<LibraryGame[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(
    () =>
      api
        .get<LibraryResponse>('/me/library')
        .then((data) => {
          setGames(data.games)
          setError(null)
        })
        .catch((e: unknown) => {
          setError(e instanceof Error ? e.message : 'Could not load your library.')
        })
        .finally(() => {
          setIsLoading(false)
        }),
    [],
  )

  useEffect(() => {
    refresh()
  }, [refresh])

  return { games, isLoading, error, refresh }
}
